import { render, staticRenderFns } from "./InvoicePDFDownload.vue?vue&type=template&id=1648a900&"
import script from "./InvoicePDFDownload.vue?vue&type=script&lang=js&"
export * from "./InvoicePDFDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports